export default __webpack_public_path__ + "static/media/match.3c25253c.png";